import getReleaseHostname from "@/utils/getReleaseHostname.js";

let apiBaseURL = "";
// const isHttps = /^https/.test(window.location.protocol);
let hostnamePrefix = "erp-stable";
// let hostnamePrefix = "erp-main";
if (localStorage.getItem("qaEnv") && localStorage.getItem("qaEnvNum")) {
  hostnamePrefix = `${localStorage.getItem("qaEnv")}${localStorage.getItem(
    "qaEnvNum"
  )}`;
}
switch (process.env.NODE_ENV) {
  case "test":
    apiBaseURL = `//${hostnamePrefix || "erp1"}.yishou.com`;
    break;
  case "staging":
    apiBaseURL = `https://${getReleaseHostname()}.yishouapp.com`;
    break;
  case "production":
    apiBaseURL = "https://erp.yishouapp.com";
    break;

  default:
    break;
}
const apiBaseURLConst = apiBaseURL;
export default apiBaseURLConst;



// WEBPACK FOOTER //
// ./src/utils/baseUrl.js